import TabapayTransferScreen from 'features/moveMoney/screens/dcf/tabapay/TabapayTransfer/TabapayTransferScreen';
import React from 'react';

export default function TabapayTransferScreenPage() {
  return <TabapayTransferScreen />;
}
